import AmexTabbedCarouselRefresh from './AmexTabbedCarouselRefresh';

export default AmexTabbedCarouselRefresh;
